import React, { useState, useEffect, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Trash from "../../../../../assets/images/trash.png";
import Table from 'react-bootstrap/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faPlus, faGear, faCircleXmark, faCircleInfo, faCircleQuestion, faTruckRampBox } from '@fortawesome/free-solid-svg-icons';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Badge from 'react-bootstrap/Badge';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import Docmnt from "../../../../../assets/images/file.svg";

import { withoutRFSToken, withRFSToken } from '../../../../../Services/axios.js';
import { GETTYPECODE, GETOWNERCODE, GETCONDITIONCODE, GETDAMAGETYPE, GETDESTINATION, ULDREPAIRUPDATE, ULDALLUPDATE, GETCONTENTCODE, STTRUPDATE, ULDEXISTS } from '../../../../../Utils/conts.js';
import { toast } from 'react-toastify';
import Loader from '../../../../../Components/common/Loader.js';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchTypeCode,
  fetchContentCode,
  fetchOwnerCode,
  fetchCondCode,
  fetchDamageType,
  fetchDestination,
} from '../../../../../redux/api/apiSlice.js';

const Details = ({ uldData }) => {

  // const queryParameters = new URLSearchParams(window.location.search);
  // const type = queryParameters.get("action");
  // const uldids = queryParameters.get("ids");

  const actionTypes = ['Repair In', 'Repair Out', 'SCM', 'Lease Out', 'UCM Out', 'UCM In', 'LUC In', 'LUC Out', 'Transfer', 'Request'];
  let keyType = null;
  // Loop through the actionTypes array
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    // Check if the current key matches any of the action keyTypes
    if (actionTypes.includes(key)) {
      keyType = key;
      break;
    }
  }

  const isMountedR = useRef(false);

  // const dispatch = useDispatch();
  // const typeCodes = useSelector((state) => state.api.typeCodes);
  // const contentCodes = useSelector((state) => state.api.contentCodes);
  // const ownerCodes = useSelector((state) => state.api.ownerCodes);
  // const condCodes = useSelector((state) => state.api.condCodes);
  // const damageTypes = useSelector((state) => state.api.damageTypes);
  // const destinations = useSelector((state) => state.api.destinations);

  // const formDatas = useSelector((state) => state.uld.formData);
  // const status = useSelector((state) => state.uld.status);
  // const error = useSelector((state) => state.uld.error);


  const isMounted = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const [getTypeCodes, setGetTypeCodes] = useState([]);
  const [getOwnerCodes, setGetOwnerCode] = useState([]);
  const [getContentCodes, setGetContentCode] = useState([]);
  const [getCondCodes, setGetCondCode] = useState([]);
  const [damageType, setDamageType] = useState([]);
  const [getDestination, setGetDestination] = useState([]);
  const [scmModal, setScmModal] = useState(false);
  const [scmResponseData, setScmResponseData] = useState();

  const [formData, setFormData] = useState([]);

  useEffect(() => {
    // setScmModal(true)
    // Retrieve the data from localStorage ON LOAD
    const keys = ['Repair In', 'Repair Out', 'SCM', 'Lease Out', 'UCM Out', 'UCM In', 'LUC In', 'LUC Out', 'Transfer', 'Request'];

    let storedData = null;
    // Iterate over the keys and retrieve the first non-null value from localStorage
    for (const key of keys) {
      storedData = localStorage.getItem(key);
      if (storedData) break;
    }
    const parsedData = storedData ? JSON.parse(storedData) : null;

    // Set the ULD data to the state
    if (parsedData && parsedData.ULD) {
      setFormData(parsedData.ULD);
    }


  }, []);
  const fetchDataFromLocalStorage = () => {
    const keys = ['Repair In', 'Repair Out', 'SCM', 'Lease Out', 'UCM Out', 'UCM In', 'LUC In', 'LUC Out', 'Transfer', 'Request'];

    let storedData = null;
    // Iterate over the keys and retrieve the first non-null value from localStorage
    for (const key of keys) {
      storedData = localStorage.getItem(key);
      if (storedData) break;
    }
    const parsedData = storedData ? JSON.parse(storedData) : null;
    console.log('888', parsedData);
    // Set the ULD data to the state
    if (parsedData && parsedData.ULD) {
      setFormData(parsedData.ULD);
    }
  };
  useEffect(() => {
    // Initial fetch of data
    // fetchDataFromLocalStorage();
    // Event listener for localStorage updates

    const handleLocalStorageUpdate = () => {
      fetchDataFromLocalStorage();
    };

    window.addEventListener('localStorageUpdated', handleLocalStorageUpdate);
    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('localStorageUpdated', handleLocalStorageUpdate);
    };
  }, []);

  const fetchData = async () => {
    try {

      const res = await withRFSToken.post(GETTYPECODE, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.uld_typecode,
            label: item.uld_typecode
          })) : [];
          setGetTypeCodes(transformedData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchContentCode = async () => {
    try {
      const res = await withRFSToken.post(GETCONTENTCODE, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          // const transformedData = innerData ? innerData.map(item => ({
          //   value: item.IATA,
          //   label: item.IATA
          // })) : [];
          setGetContentCode(innerData);
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchOwnerCode = async () => {
    try {
      const res = await withRFSToken.post(GETOWNERCODE, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.IATA,
            label: item.IATA
          })) : [];
          setGetOwnerCode(transformedData);
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchCondCode = async () => {
    try {

      const res = await withRFSToken.post(GETCONDITIONCODE, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          setGetCondCode(innerData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDamageType = async () => {
    try {
      const res = await withRFSToken.post(GETDAMAGETYPE, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          setDamageType(innerData);
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const fetchDestination = async () => {
    try {

      const res = await withRFSToken.post(GETDESTINATION, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.port_code,
            label: item.port_code,
          })) : [];
          setGetDestination(transformedData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {

    // Call the fetchData function to fetch data from the API
    if (isMounted.current) return;
    fetchData();
    fetchOwnerCode();
    fetchContentCode();
    fetchCondCode();
    fetchDamageType();
    fetchDestination();
    isMounted.current = true;
  }, []);

  const removeDetails = (id) => {

    if (['UCM Out', 'UCM In'].includes(keyType)) {
      console.log('id', id);
      setFormData(prevFormData => prevFormData.filter((stack, index) => index !== id));

      const scmData = JSON.parse(localStorage.getItem(keyType)) || { ULD: [] };
      scmData.ULD = scmData.ULD.filter((item, index) => index !== id);
      localStorage.setItem(keyType, JSON.stringify(scmData));
    } else {
      setFormData(prevFormData => prevFormData.filter(stack => stack.uld_number !== id));

      const scmData = JSON.parse(localStorage.getItem(keyType)) || { ULD: [] };
      scmData.ULD = scmData.ULD.filter(item => item.uld_number !== id);
      localStorage.setItem(keyType, JSON.stringify(scmData));
    }

  }

  // const handleDetailsChange = (id, field, value) => {
  //   setFormData(prevFormData =>
  //     prevFormData.map(stack =>
  //       stack.uld_number === id ? { ...stack, [field]: value } : stack
  //     )
  //   );
  //   // working 24.05.23
  // };
  const handleChange = (value) => {
    value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
    let formattedValue = '';

    // Add a hyphen after the third character
    if (value.length > 3) {
      formattedValue += value.substr(0, 3) + '-';
      value = value.substr(3);
    }

    // Add a space after the eighth character
    if (value.length > 4) {
      formattedValue += value.substr(0, 4) + ' ';
      value = value.substr(4);
    }

    formattedValue += value;
    return formattedValue.substr(0, 13);
  };

  const handleCheckUld = async (id, val) => {
    try {
      const res = await withRFSToken.post(ULDEXISTS, { uld_number: val });
      if (res.data.response_code == 200) {
        const innerData = res.data.response_data;

        const reg = innerData.reg;
        const asset_type = innerData.asset_type;

        setFormData(prevFormData =>
          prevFormData.map((stack, index) => {
            if (index === id) {
              const updatedStack = { ...stack, reg, asset_type };

              // updatedStack.uld_number = `${updatedStack.type_code || ''}${updatedStack.serial_number || ''}${updatedStack.owner_code || ''}`;

              const keyData = JSON.parse(localStorage.getItem(keyType)) || { ULD: {} };
              keyData.ULD = keyData.ULD.map((item, index) => index === id ? updatedStack : item);
              localStorage.setItem(keyType, JSON.stringify(keyData));

              return updatedStack;
            }
            return stack;
          })
        );
      } else {
        setFormData(prevFormData =>
          prevFormData.map((stack, index) => {
            if (index === id) {
              const reg = false;
              const updatedStack = { ...stack, reg };
              // updatedStack.uld_number = `${updatedStack.type_code || ''}${updatedStack.serial_number || ''}${updatedStack.owner_code || ''}`;

              const keyData = JSON.parse(localStorage.getItem(keyType)) || { ULD: {} };
              keyData.ULD = keyData.ULD.map((item, index) => index === id ? updatedStack : item);
              localStorage.setItem(keyType, JSON.stringify(keyData));

              return updatedStack;
            }
            return stack;
          })
        );
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const handleUldChange = (rowId, field, value) => {
    const updatedData = formData.map((item, index) => {
      if (index === rowId) {
        const updatedItem = {
          ...item,
          [field]: value
        };
        if (
          (field === "type_code" || field === "serial_number" || field === "owner_code") &&
          updatedItem.type_code && updatedItem.serial_number && updatedItem.owner_code
        ) {
          updatedItem.uld_number = updatedItem.type_code + updatedItem.serial_number + updatedItem.owner_code;
        }
        // return {
        //   ...item,
        //   [field]: value,
        //   uld_number:
        //     (field === "type_code" ? value : item.type_code || "") +
        //     (field === "serial_number" ? value : item.serial_number || "") +
        //     (field === "owner_code" ? value : item.owner_code || "")
        // };
        return updatedItem;
      }
      return item;
    });

    setFormData(updatedData);

    const keyData = JSON.parse(localStorage.getItem(keyType)) || { ULD: {} };
    const updatedRow = updatedData.find((i, index) => index === rowId);
    // keyData.ULD = keyData.ULD.map(item => item.rowId === rowId ? updatedData : item);
    keyData.ULD = [...keyData.ULD.filter((item, index) => index !== rowId), updatedRow];
    localStorage.setItem(keyType, JSON.stringify(keyData));

    if (updatedRow?.type_code && updatedRow?.serial_number && updatedRow?.owner_code) {
      const uldNumber = updatedRow?.type_code + updatedRow?.serial_number + updatedRow?.owner_code
      handleCheckUld(rowId, uldNumber);
    }
  };


  const handleDetailsChange = async (id, fieldName, value) => {

    if (fieldName === 'awb_number') {
      value = handleChange(value);
    }

    if (fieldName === 'owner_code') {
      const filteredData = formData.filter(item => item.uld_number === id);
      const nmbr = `${filteredData[0].type_code}${filteredData[0].serial_number}${value}`;
      try {
        const res = await withRFSToken.post(ULDEXISTS, { uld_number: nmbr });
        if (res.data.response_code == 200) {
          const innerData = res.data.response_data;

          // Process the API response to get regd and asset_type
          const reg = innerData.reg;  // Replace with actual field from the response
          const asset_type = innerData.asset_type;

          setFormData(prevFormData =>
            prevFormData.map(stack => {
              if (stack.uld_number === id) {
                const updatedStack = { ...stack, [fieldName]: value, reg, asset_type };
                updatedStack.uld_number = `${updatedStack.type_code || ''}${updatedStack.serial_number || ''}${updatedStack.owner_code || ''}`;

                const keyData = JSON.parse(localStorage.getItem(keyType)) || { ULD: {} };
                keyData.ULD = keyData.ULD.map(item => item.uld_number === id ? updatedStack : item);
                localStorage.setItem(keyType, JSON.stringify(keyData));

                return updatedStack;
              }
              return stack;
            })
          );
        } else {
          setFormData(prevFormData =>
            prevFormData.map(stack => {
              if (stack.uld_number === id) {
                const reg = false;
                const updatedStack = { ...stack, [fieldName]: value, reg };
                updatedStack.uld_number = `${updatedStack.type_code || ''}${updatedStack.serial_number || ''}${updatedStack.owner_code || ''}`;

                const keyData = JSON.parse(localStorage.getItem(keyType)) || { ULD: {} };
                keyData.ULD = keyData.ULD.map(item => item.uld_number === id ? updatedStack : item);
                localStorage.setItem(keyType, JSON.stringify(keyData));

                return updatedStack;
              }
              return stack;
            })
          );
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      }

    } else {
      setFormData(prevFormData =>
        prevFormData.map(stack => {
          if (stack.uld_number === id) {
            const updatedStack = { ...stack, [fieldName]: value };
            updatedStack.uld_number = `${updatedStack.type_code || ''}${updatedStack.serial_number || ''}${updatedStack.owner_code || ''}`;

            const keyData = JSON.parse(localStorage.getItem(keyType)) || { ULD: {} };
            keyData.ULD = keyData.ULD.map(item => item.uld_number === id ? updatedStack : item);
            localStorage.setItem(keyType, JSON.stringify(keyData));

            return updatedStack;
          }
          return stack;
        })
      );
    }
    console.log('123', formData);
  };

  // Add Section Start
  const addULDStack = () => {
    // const lastId = formData.length > 0 ? parseInt(formData[formData.length - 1].rowId) : 0;
    // const newId = lastId + 1;
    // setFormData(prevFormData => ([
    //   ...prevFormData,
    //   {
    //     // id: (prevFormData.uldStack.length + 1).toString(),
    //     rowId: newId,
    //     type_code: '',
    //     uld_number: '',
    //     serial_number: '',
    //     owner_code: '',
    //     condition_code: 'SER',
    //     airline_name: '',
    //     asset_type: false,
    //     disabled: false
    //   }
    // ]));
    const newRow = {
      // rowId: newId,
      type_code: '',
      uld_number: '',
      serial_number: '',
      owner_code: '',
      condition_code: 'SER',
      airline_name: '',
      asset_type: false,
      disabled: false
    };
    const updatedFormData = [...formData, newRow];
    setFormData(updatedFormData);

    const keyData = JSON.parse(localStorage.getItem(keyType)) || { ULD: [] };
    keyData.ULD = [...keyData.ULD, newRow];
    localStorage.setItem(keyType, JSON.stringify(keyData));

  };
  const removeULDStack = (uldInfoId) => {
    setFormData(prevFormData => {
      return {
        ...prevFormData,
        uldInfo: prevFormData.uldInfo.filter(stack => stack.id !== uldInfoId)
      };
    });
  };
  // Add Section End

  const [showModal, setShowModal] = useState(false);

  const [modalRadioValue, setModalRadioValue] = useState({ assetType: '' });
  const [modalContent, setModalContent] = useState('');
  const handleModalClose = () => { setShowModal(false); setModalRadioValue('') };

  const handleModalOpen = (contentType) => {
    setModalContent(contentType);
    setShowModal(true);
  };
  const handleConfirmation = (confirm) => {
    if (confirm) {
      setShowModal(false);
      window.location.href = '/ULDControl'
    } else {
      setShowModal(false);
    }
  }
  const handleModalRadioChange = (event) => {
    const { name, value } = event.target;
    setModalRadioValue({ [name]: value });
  };

  const handleModalUpdate = () => {
    if (modalContent === 'regChange') {
      const updatedRegType = modalRadioValue.regType === 'R' ? 'R' : false;

      const updatedFormData = formData.map(stack => {
        return {
          ...stack,
          regd: updatedRegType
        };
      });

      setFormData(updatedFormData);
      const keyData = JSON.parse(localStorage.getItem(keyType)) || { ULD: {} };
      keyData.ULD = updatedFormData;
      localStorage.setItem(keyType, JSON.stringify(keyData));

    } else {
      const updatedAssetType = modalRadioValue.assetType === 'O' ? false : true;
      // const updatedFormData = formData.map(stack => ({
      //     ...stack,
      //     asset_type: updatedAssetType
      //   }))
      const updatedFormData = formData.map(stack => {
        if (stack.regd == 'R') {
          return {
            ...stack,
            asset_type: updatedAssetType
          };
        }
        return stack; // Return unchanged rows
      });

      setFormData(updatedFormData);
      const keyData = JSON.parse(localStorage.getItem(keyType)) || { ULD: {} };
      keyData.ULD = updatedFormData;
      localStorage.setItem(keyType, JSON.stringify(keyData));
    }
    setModalRadioValue('')
    setShowModal(false);
  };

  const validateFormData = () => {
    let isValid = true;

    // Retrieve data from local storage
    const storedData = JSON.parse(localStorage.getItem(keyType));

    if (!storedData) {
      toast.error('No data found');
      return false;
    }

    // Validate Form fields
    if (keyType == 'Repair In') {
      const form = storedData.Form;
      if (!form.repair_station) {

        toast.error('Please set Repair Station');
        isValid = false;
      } else if (!form.repair_in) {
        toast.error('Please set Repair In');
        isValid = false;
      }
    } else if (keyType == 'Repair Out') {
      const form = storedData.Form;
      if (!form.repair_station) {

        toast.error('Please set Repair Station');
        isValid = false;
      } else if (!form.repair_out) {
        toast.error('Please set Repair Out');
        isValid = false;
      }
    } else if (keyType == 'LUC In') {
      const form = storedData.Form;
      if (!form.return_date) {

        toast.error('Please Insert Return Date');
        isValid = false;
      } else if (!form.transfer_point) {
        toast.error('Please Insert Transfer Point');
        isValid = false;
      } else if (!form.returned_by) {
        toast.error('Please Insert Returned By');
        isValid = false;
      } else if (!form.return_station) {
        toast.error('Please Insert Return Station');
        isValid = false;
      } else if (!form.return_handler) {
        toast.error('Please Insert Returned Handler');
        isValid = false;
      }
    } else if (keyType == 'UCM In' || keyType == 'UCM Out') {
      const form = storedData.Form;
      if (!form.flight_code) {

        toast.error('Please set Flight Number');
        isValid = false;
      } else if (!form.flight_number) {

        toast.error('Please set Flight Number');
        isValid = false;
      } else if (!form.flight_date) {

        toast.error('Please set Flight Date');
        isValid = false;
      } else if (!form.destination) {

        toast.error('Please set Destination');
        isValid = false;
      }
    } else if (keyType == 'UCM Out') {
      const form = storedData.Form;
      if (!form.origin) {

        toast.error('Please set Origin');
        isValid = false;
      }
    } else if (keyType == 'Transfer' || keyType == 'Received') {
      const form = storedData.Form;
      if (!form.transfer_date) {

        toast.error('Please set Transfer Date');
        isValid = false;
      } else if (!form.transfer_point) {

        toast.error('Please set Transfer Point');
        isValid = false;
      } else if (!form.transferred_by) {

        toast.error('Please set Transferred By');
        isValid = false;
      } else if (!form.luc_final_dest) {

        toast.error('Please set Final Destination');
        isValid = false;
      } else if (!form.received_by) {

        toast.error('Please set Received By');
        isValid = false;
      } else if (form.transfer_point == form.luc_final_dest) {

        toast.error('Transfer Point and Final Destination should not be same');
        isValid = false;
      }
    }

    // Validate ULD array
    // const ulds = storedData.ULD;
    // if (ulds && ulds.length > 0) {
    //   for (let i = 0; i < ulds.length; i++) {
    //     const uld = ulds[i];
    //     if (!uld.type_code) {
    //       toast.error('Please set Type Code');
    //       isValid = false;
    //       break;
    //     }

    //     if (!uld.owner_code) {
    //       toast.error('Please set Owner Code');
    //       isValid = false;
    //       break;
    //     }
    //     if (!uld.condition_code) {
    //       toast.error('Please set Condition Code');
    //       isValid = false;
    //       break;
    //     }
    //   }
    // } else {
    //   toast.error('ULD data is missing or empty');
    //   isValid = false;
    // }
    return isValid;
  };

  const updateData = async (process) => {
    if (validateFormData()) {
      setIsLoading(true);
      try {
        // Retrieve data from local storage
        const mvtData = JSON.parse(localStorage.getItem(keyType));
        if (mvtData) {
          if (['Repair In', 'Repair Out'].includes(keyType)) {
            const actiontype = keyType == 'Repair In' ? 'repair_in' : (keyType == 'Repair Out' ? 'repair_out' : keyType);
            const dataToSend = { ...mvtData, action: actiontype };
            const res = await withRFSToken.post(ULDREPAIRUPDATE, JSON.stringify(dataToSend));

            if (res.data.response_code == 200) {
              localStorage.removeItem(keyType);
              const backUrl = '/ULDControl';
              window.location.href = backUrl;
              setIsLoading(false);
            } else {
              toast.error(res.data.response_msg);
              setIsLoading(false);
            }

          } else if (['Transfer', 'Request'].includes(keyType)) {
            const keyTypeMapping = {
              'Transfer': 'ST',
              'Request': 'TR',
            };
            const actiontype = keyTypeMapping[keyType] || keyType;
            const dataToSend = { ...mvtData, transfer_type: actiontype };
            const res = await withRFSToken.post(STTRUPDATE, JSON.stringify(dataToSend));

            if (res.data.response_code == 200) {
              localStorage.removeItem(keyType);
              const backUrl = '/ULDControl';
              window.location.href = backUrl;
              setIsLoading(false);
            } else {
              toast.error(res.data.response_msg);
              setIsLoading(false);
            }
          }
          //  else if (['UCM Out'].includes(keyType)) {
          //   setScmModal(true);
          //  }
          else if (['SCM', 'UCM Out'].includes(keyType)) {
            // const actiontype = keyTypeMapping[keyType] || keyType;
            const dataToSend = { ...mvtData, action: keyType == 'UCM Out' ? 'UO' : keyType, action_type: process == 'P' ? 'P' : 'U', ...scmResponseData };
            const res = await withRFSToken.post(ULDALLUPDATE, JSON.stringify(dataToSend));
            if (res.data.response_code == 200) {
              const innerData = res.data.response_data
              if (process !== 'P') {
                if (innerData.missing_uld_count > 0 || innerData.unexpected_stock_count > 0) {
                  setScmResponseData(innerData);
                  setScmModal(true);
                  setIsLoading(false);
                } else {
                  const resData = { ...mvtData, action: keyType == 'UCM Out' ? 'UO' : keyType, action_type: 'P', ...scmResponseData };
                  const ress = await withRFSToken.post(ULDALLUPDATE, JSON.stringify(resData));
                  if (ress.data.response_code == 200) {
                    localStorage.removeItem(keyType);
                    const backUrl = '/ULDControl';
                    window.location.href = backUrl;
                    setIsLoading(false);
                  }
                }

              } else {
                localStorage.removeItem(keyType);
                const backUrl = '/ULDControl';
                window.location.href = backUrl;
                setIsLoading(false);
              }
            } else {
              toast.error(res.data.response_msg);
              setIsLoading(false);
            }
          } else {
            const keyTypeMapping = {
              'Lease Out': 'LEO',
              'UCM Out': 'UO',
              'SCM': 'SCM',
              'UCM In': 'UI',
              'LUC In': 'LI',
              'LUC Out': 'LO',
            };
            const actiontype = keyTypeMapping[keyType] || keyType;
            // const actiontype = keyType == 'Repair In' ? 'repair_in' : (keyType == 'Repair Out' ? 'repair_out' : keyType); action_type: U/P
            const dataToSend = { ...mvtData, action: actiontype };
            const res = await withRFSToken.post(ULDALLUPDATE, JSON.stringify(dataToSend));

            if (res.data.response_code == 200) {
              localStorage.removeItem(keyType);
              const backUrl = '/ULDControl';
              window.location.href = backUrl;
              setIsLoading(false);
            } else {
              toast.error(res.data.response_msg);
              setIsLoading(false);
            }

          }

        }
      } catch (error) {
        console.error('Error while sending data to the API:', error);
      }
    }
  }

  // upload Section
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);

  // const imageModalUpload = (id) => {
  //     setSelectedRowId(id);
  //     setShowModalUpload(true)
  //     setFiles([])
  // }
  const imageModalUpload = (id) => {
    console.log('aaaa', id);
    const selectedRowFiles = formData.find(item => item.uld_number === id)?.files || [];
    setFiles(selectedRowFiles);
    setSelectedRowId(id); // Store the ID of the selected row
    setShowModalUpload(true);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    getBase64(droppedFiles[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    base64Files.splice(index, 1);
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const filesWithBase64 = [];

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        // filesWithBase64.push({ file, base64: reader.result });
        filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
        if (filesWithBase64.length === selectedFiles.length) {
          setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);
          // setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => obj.base64)]);
          setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
        }
      };
      reader.readAsDataURL(file);
    });
  };
  // const imageUpload = () => {
  //   setFormData(prevFormData =>
  //     prevFormData.map(item => {
  //       if (item.uld_number === selectedRowId) {
  //         return { ...item, files: files, base64Files: base64Files };
  //       }
  //       return item;
  //     })
  //   );
  //   setShowModalUpload(false);
  // };
  const imageUpload = () => {
    setFormData(prevFormData => {
      const updatedFormData = prevFormData.map(item => {
        if (item.uld_number === selectedRowId) {
          return { ...item, files, base64Files };
        }
        return item;
      });

      // Update local storage
      const keyData = JSON.parse(localStorage.getItem(keyType)) || { ULD: [] };
      keyData.ULD = keyData.ULD.map(item => {
        if (item.uld_number === selectedRowId) {
          return { ...item, files: base64Files, base64Files: base64Files };
        }
        return item;
      });
      localStorage.setItem(keyType, JSON.stringify(keyData));

      return updatedFormData;
    });
    setFiles([]);
    setBase64Files([])
    setShowModalUpload(false);
  };

  const handleAllChange = (e, type) => {
    const newAction = e.target.value;
    if (type === "missing") {
      setScmResponseData((prevData) => ({
        ...prevData,
        missing_ulds: prevData.missing_ulds.map((uld) => ({
          ...uld,
          action: newAction,
        })),
      }));
    } else {
      setScmResponseData((prevData) => ({
        ...prevData,
        unexpected_stock_ulds: prevData.unexpected_stock_ulds.map((uld) => ({
          ...uld,
          action: newAction,
        })),
      }));
    }
  };

  const handleActionChange = (e, index, type) => {
    const selectedValue = e.target.value;

    setScmResponseData((prevData) => {
      const updatedData = { ...prevData };

      if (type === "missing") {
        updatedData.missing_ulds[index].action = selectedValue;
      } else if (type === "unknown") {
        updatedData.unexpected_stock_ulds[index].action = selectedValue;
      }

      return { ...updatedData }; // Ensure re-render
    });
  };


  return (
    <>
      {isLoading &&
        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
      }
      {console.log('000000000000000 formData', formData)}
      <div className='mb-3 nestedtabs rounded details_h'>
        <div className='d-flex justify-content-between align-items-center charter_top'>
          <div className='d-flex align-items-center'><h3 className='mb-0'>ULD Details</h3>  <span className='selected'>Selected ULDs <Badge>{formData.length}</Badge> </span></div>
          <div className='alltype'>
            {keyType !== 'Repair In' && keyType !== 'Repair Out' ?
              (<>
                <button keyType="button" className="btn btn-outline-secondary me-1" onClick={() => handleModalOpen('regChange')}> <FontAwesomeIcon icon={faGear} /> Register All </button>
                <button keyType="button" className="btn btn-outline-secondary" onClick={() => handleModalOpen('assetTypeChange')}> <FontAwesomeIcon icon={faGear} /> All Asset Type </button>
              </>) : (<></>)}
          </div>
        </div>
        {keyType == 'Repair In' || keyType == 'Repair Out' ? (
          <>
            <div className='table-responsive repar_h'>
              <Table className='uld_details ra_repair'>
                <thead>
                  <tr>
                    <th>ULD Number</th>
                    <th>Type Code</th>
                    <th>Serial Number</th>
                    <th>Owner Code</th>
                    {/* <th>Condition</th> */}
                    <th className='wdht'>Damage Type</th>
                    <th>Damage Desc.</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {formData && formData.map((section, index) => {
                    return (
                      <tr key={index}>{console.log('666', formData)}{console.log('667', section)}
                        <td><Form.Control type="text" readOnly value={section.uld_number} onChange={(e) => handleDetailsChange(section.uld_number, 'uld_number', e.target.value)} /></td>
                        <td>
                          {/* <Form.Select aria-label="Default" value={section.type_code}>
                            {getTypeCodes &&
                              getTypeCodes.map((option, index) =>
                                <option key={index} value={option.uld_typecode}>{option.uld_typecode}</option>
                              )
                            }
                          </Form.Select> */}
                          <Select
                            options={getTypeCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'type_code', e.value)}
                            placeholder="Type Code"
                            className='autoslct'
                            name="type_code"
                            value={getTypeCodes.find(option => option.value === section.type_code)}
                            isDisabled={section.register == 'Y' ? true : false}
                          />
                        </td>
                        <td><Form.Control type="text" readOnly value={section.serial_number} onChange={(e) => handleDetailsChange(section.uld_number, 'serial_number', e.target.value)} /></td>
                        <td>
                          {/* <Form.Select aria-label="Default" value={section.owner_code}>
                            {getOwnerCodes &&
                              getOwnerCodes.map((option, index) =>
                                <option key={index} value={option.IATA}>{option.IATA}</option>
                              )
                            }
                          </Form.Select> */}
                          <Select
                            options={getOwnerCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'owner_code', e.value)}
                            placeholder="Owner Code"
                            className='autoslct'
                            name="owner_code"
                            value={getOwnerCodes.find(option => option.value === section.owner_code)}
                            isDisabled={section.register == 'Y' ? true : false}
                          />
                        </td>
                        {/* <td>
                          <Form.Select 
                          aria-label="Default" 
                          value={section.condition_code == 'Damaged' ? 'DAM' : (section.condition_code == 'Discarded' ? 'DIS' : 'SER')} 
                          onChange={(e) => handleDetailsChange(section.uld_number, 'condition_code', e.target.value)}
                          >
                            {getCondCodes &&
                              Object.entries(getCondCodes).map((option, index) =>
                                <option key={index} value={option[0]}>{option[1]}</option>
                              )
                            }
                          </Form.Select>
                        </td> */}
                        <td>
                          {/* <Form.Select aria-label="Default">
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                          </Form.Select> */}
                          <Select
                            options={damageType}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'damage_type', e.value)}
                            placeholder="Damage Type"
                            className='autoslct'
                            name="damage_type"
                            value={damageType.find(option => option.value === section.damage_type)}
                          />
                        </td>
                        <td><Form.Control type="text" name='damage_desc' value={section.damage_desc} onChange={(e) => handleDetailsChange(section.uld_number, 'damage_desc', e.target.value)} /></td>
                        <td className='inbox text-center'><Button variant="outline-primary" className='upfile' onClick={() => imageModalUpload(section.uld_number)}>Upload file {section.files && section.files.length > 0 ? section.files.length : ''}</Button></td>
                        <td>
                          <img src={Trash} onClick={() => removeDetails(section.uld_number)} />
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          </>
        ) : (keyType == 'Lease Out' ? (
          <>
            <div className='table-responsive repar_h'>
              <Table className='uld_details'>
                <thead>
                  <tr>
                    <th>ULD Number</th>
                    <th>Type Code</th>
                    <th>Serial No</th>
                    <th>Owner Code</th>
                    {/* <th>Content</th>
                    <th>Final Dest.</th> */}
                    <th>Condition</th>
                    <th className='non_reg'>ULD Asset</th>
                    <th>Register</th>
                    <th>Asset Type </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {formData && formData.map((section, index) => {
                    return (
                      <tr key={index}>
                        <td><Form.Control type="text" readOnly value={section.uld_number} onChange={(e) => handleDetailsChange(section.uld_number, 'uld_number', e.target.value)} /></td>
                        <td>
                          <Select
                            options={getTypeCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'type_code', e.value)}
                            placeholder="Type Code"
                            className='autoslct'
                            name="type_code"
                            value={getTypeCodes.find(option => option.value === section.type_code)}
                            isDisabled={section.register == 'Y' ? true : false}
                          />
                        </td>
                        <td><Form.Control type="text" readOnly value={section.serial_number} onChange={(e) => handleDetailsChange(section.uld_number, 'serial_number', e.target.value)} /></td>
                        <td>
                          <Select
                            options={getOwnerCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'owner_code', e.value)}
                            placeholder="Owner Code"
                            className='autoslct'
                            name="owner_code"
                            value={getOwnerCodes.find(option => option.value === section.owner_code)}
                            isDisabled={section.register == 'Y' ? true : false}
                          />
                        </td>
                        {/* <td>
                          <Form.Control type="text" value={section.content_code} name="content_code" onChange={(e) => handleDetailsChange(section.uld_number, 'content_code', e.target.value)} />
                        </td>
                        <td>
                          <Select
                            options={getDestination}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'destination', e.value)}
                            placeholder="Destination"
                            className='autoslct'
                            name="destination"
                            value={getTypeCodes.find(option => option.value === section.destination)}
                          />
                        </td> */}
                        <td>
                          <Form.Select
                            aria-label="Default"
                            value={section.condition_code} // == 'Damaged' ? 'DAM' : (section.condition_code == 'Discarded' ? 'DIS' : 'SER')
                            onChange={(e) => handleDetailsChange(section.uld_number, 'condition_code', e.target.value)}
                          >
                            {getCondCodes &&
                              Object.entries(getCondCodes).map((option, index) =>
                                <option key={index} value={option[0]}>{option[1]}</option>
                              )
                            }
                          </Form.Select>
                        </td>
                        {section.register == 'Y' ?
                          (
                            <>
                              <td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td>
                              <td className='rayes'>

                                {/* <div className="can-toggle">
                                  <input
                                    id={`a${section.uld_number}_d`} type="checkbox"
                                    disabled
                                    // ={section.reg && section.reg === 'R'} 
                                    checked
                                  // ={section.reg && section.reg === 'R'} 
                                  />
                                  <label htmlFor={`a${section.uld_number}_d`}>
                                    <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                                  </label>
                                </div> */}
                              </td>
                              <td></td>
                            </>
                          ) : (
                            <>
                              {section.regd == 'R' ?
                                (<><td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td></>
                                ) : (<><td className='non_register'><FontAwesomeIcon icon={faCircleXmark} /> Non-Registered</td></>)}
                              <td className='rayes'>
                                <div className="can-toggle">
                                  <input
                                    id={`a${section.uld_number}_${index}`}
                                    type="checkbox"
                                    checked={section.regd === 'R'}
                                    onChange={(e) => handleDetailsChange(section.uld_number, 'regd', e.target.checked ? 'R' : false)} />
                                  <label htmlFor={`a${section.uld_number}_${index}`}>
                                    <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                                  </label>
                                </div>
                              </td>
                              <td>
                                {section.regd == 'R' &&
                                  <div className='chart_switch'>
                                    <div className="switch6">
                                      <label className="switch6-light">
                                        <input type="checkbox"
                                          name="asset_type"
                                          checked={section.asset_type}
                                          onChange={(e) => handleDetailsChange(section.uld_number, 'asset_type', e.target.checked)} />
                                        <span>
                                          <span>Owned</span>
                                          <span>Lease</span>
                                        </span>
                                        <a className="btn btn-primary"></a>
                                      </label>
                                    </div>
                                  </div>
                                }
                              </td>
                            </>
                          )
                        }

                        <td>
                          <img src={Trash} onClick={() => removeDetails(section.uld_number)} />
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          </>
        ) : (keyType == 'LUC In' ? (
          <>
            <div className='table-responsive luc_h'>
              <Table className='uld_details'>
                <thead>
                  <tr>
                    <th>ULD Number</th>
                    <th>Type Code</th>
                    <th>Serial No</th>
                    <th>Owner Code</th>
                    {/* <th>Content</th> */}
                    {/* <th>Final Dest.</th> */}
                    <th>Condition</th>
                    <th className='non_reg'>ULD Asset</th>
                    <th>Register</th>
                    <th>Asset Type </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {formData && formData.map((section, index) => {
                    return (
                      <tr key={index}>
                        <td><Form.Control type="text" readOnly value={section.uld_number} /></td>
                        <td>
                          <Select
                            options={getTypeCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'type_code', e.value)}
                            placeholder="Type Code"
                            className='autoslct'
                            name="type_code"
                            value={getTypeCodes.find(option => option.value === section.type_code)}
                            isDisabled={true}
                          />
                        </td>
                        <td><Form.Control type="text" readOnly value={section.serial_number} /></td>
                        <td>
                          <Select
                            options={getOwnerCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'owner_code', e.value)}
                            placeholder="Owner Code"
                            className='autoslct'
                            name="owner_code"
                            value={getOwnerCodes.find(option => option.value === section.owner_code)}
                            // isDisabled={true}
                            isDisabled={section?.disabled == false || section?.register == 'N' ? false : true}
                          />
                        </td>

                        <td>
                          <Form.Select aria-label="Default" value={section.condition_code} name="condition_code" onChange={(e) => handleDetailsChange(section.uld_number, 'condition_code', e.target.value)}>
                            {getCondCodes &&
                              Object.entries(getCondCodes).map((option, index) =>
                                <option key={index} value={option[0]}>{option[1]}</option>
                              )
                            }
                          </Form.Select>
                        </td>
                        {section.reg === 'R' || section.register == 'Y' ?
                          (
                            <>
                              <td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td>
                              <td className='rayes'>

                                {/* <div className="can-toggle">
                                  <input
                                    id={`a${section.uld_number}_d`} type="checkbox"
                                    disabled
                                    // ={section.reg && section.reg === 'R'} 
                                    checked
                                  // ={section.reg && section.reg === 'R'} 
                                  />
                                  <label htmlFor={`a${section.uld_number}_d`}>
                                    <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                                  </label>
                                </div> */}
                              </td>
                              <td></td>
                            </>
                          ) : (
                            <>
                              {section.regd == 'R' || section.register == 'Y' ?
                                (<><td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td></>
                                ) : (<><td className='non_register'><FontAwesomeIcon icon={faCircleXmark} /> Non-Registered</td></>)}
                              <td className='rayes'>
                                <div className="can-toggle">
                                  <input
                                    id={`a${section.uld_number}_${index}`}
                                    type="checkbox"
                                    checked={section.regd === 'R'}
                                    onChange={(e) => handleDetailsChange(section.uld_number, 'regd', e.target.checked ? 'R' : false)} />
                                  <label htmlFor={`a${section.uld_number}_${index}`}>
                                    <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                                  </label>
                                </div>
                              </td>
                              <td>
                                {section.regd == 'R' &&
                                  <div className='chart_switch'>
                                    <div className="switch6">
                                      <label className="switch6-light">
                                        <input type="checkbox"
                                          name="asset_type"
                                          checked={section.asset_type}
                                          onChange={(e) => handleDetailsChange(section.uld_number, 'asset_type', e.target.checked)} />
                                        <span>
                                          <span>Owned</span>
                                          <span>Lease</span>
                                        </span>
                                        <a className="btn btn-primary"></a>
                                      </label>
                                    </div>
                                  </div>
                                }
                              </td>
                            </>
                          )
                        }

                        <td>
                          <img src={Trash} onClick={() => removeDetails(section.uld_number)} />
                        </td>
                      </tr>
                    )
                  })}

                </tbody>
              </Table>

              {/* <div className='text-center mt-5'>
                <Button variant="light" className='stk_cancel'>CANCEL</Button>
                <Button variant="primary" className='stk_save'>UPDATE</Button>
              </div> */}
            </div>
          </>
        ) : (keyType == 'LUC Out' ? (
          <>
            <div className='table-responsive luc_h'>
              <Table className='uld_details'>
                <thead>
                  <tr>
                    <th>ULD Number</th>
                    <th>Type Code</th>
                    <th>Serial No</th>
                    <th>Owner Code</th>
                    {/* <th>Content</th> */}
                    {/* <th>Final Dest.</th> */}
                    <th>Condition</th>
                    <th className='non_reg'>ULD Asset</th>
                    <th>Register</th>
                    <th>Asset Type </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {formData && formData.map((section, index) => {
                    return (
                      <tr key={index}>
                        <td><Form.Control type="text" readOnly value={section.uld_number} /></td>
                        <td>
                          {/* <Select
                            options={getTypeCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'type_code', e.value)}
                            placeholder="Type Code"
                            className='autoslct'
                            name="type_code"
                            value={getTypeCodes.find(option => option.value === section.type_code)}
                          /> */}
                          <Select
                            options={getTypeCodes}
                            onChange={(selected) => {
                              const updatedData = formData.uldInfo.map(item => {
                                if (item.id === section.id) {
                                  return { ...item, type_code: selected.value };
                                }
                                return item;
                              });
                              setFormData({ ...formData, uldInfo: updatedData });
                            }}
                            placeholder="Type Code"
                            className='autoslct'
                            name="type_code"
                            value={getTypeCodes.find(option => option.value === section.type_code)}
                            isDisabled={true}
                          />
                        </td>
                        <td><Form.Control type="text" readOnly value={section.serial_number} /></td>
                        <td>
                          {/* <Select
                            options={getOwnerCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'owner_code', e.value)}
                            placeholder="Owner Code"
                            className='autoslct'
                            name="owner_code"
                            value={getOwnerCodes.find(option => option.value === section.owner_code)}
                          /> */}
                          <Select
                            options={getOwnerCodes}
                            onChange={(selected) => {
                              const updatedData = formData.uldInfo.map(item => {
                                if (item.id === section.id) {
                                  return { ...item, owner_code: selected.value };
                                }
                                return item;
                              });
                              setFormData({ ...formData, uldInfo: updatedData });
                            }}
                            placeholder="Owner"
                            className='autoslct'
                            name="owner_code"
                            value={getOwnerCodes.find(option => option.value === section.owner_code)}
                            // isDisabled={true}
                            isDisabled={section?.disabled == false || section?.register == 'N' ? false : true}
                          />
                        </td>

                        {/* <td>
                          <Form.Control type="text" value={section.content_code} name="content_code" onChange={(e) => handleDetailsChange(section.uld_number, 'content_code', e.target.value)} />
                        </td> */}
                        {/* <td>
                          <Select
                            options={getDestination}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'luc_final_dest', e.value)}
                            placeholder="Destination"
                            className='autoslct'
                            name="luc_final_dest"
                            value={getDestination.find(option => option.value === section.luc_final_dest)}
                          />
                        </td> */}
                        <td>
                          <Form.Select aria-label="Default" value={section.condition_code} name="condition_code" onChange={(e) => handleDetailsChange(section.uld_number, 'condition_code', e.target.value)}>
                            {getCondCodes &&
                              Object.entries(getCondCodes).map((option, index) =>
                                <option key={index} value={option[0]}>{option[1]}</option>
                              )
                            }
                          </Form.Select>
                        </td>
                        {/* <td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td> */}
                        {/* <td className='non_register'><FontAwesomeIcon icon={faCircleXmark} /> Non-Registered </td>
                    <td className='rayes'>

                      <div className="can-toggle">
                        <input id="a" type="checkbox" />
                        <label htmlFor="a">
                          <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                        </label>
                      </div>
                    </td> */}
                        {/* {section.reg && section.reg === 'R' ?
                          (
                            <>
                              <td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td>
                              <td className='rayes'>

                                <div className="can-toggle">
                                  <input
                                    id={`a${section.uld_number}_d`} type="checkbox"
                                    disabled
                                    // ={section.reg && section.reg === 'R'} 
                                    checked
                                  // ={section.reg && section.reg === 'R'} 
                                  />
                                  <label htmlFor={`a${section.uld_number}_d`}>
                                    <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                                  </label>
                                </div>
                              </td>
                            </>
                          ) : (
                            <>
                              {section.regd == 'R' ?
                                (<><td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td></>
                                ) : (<><td className='non_register'><FontAwesomeIcon icon={faCircleXmark} /> Non-Registered</td></>)}
                              <td className='rayes'>
                                <div className="can-toggle">
                                  <input
                                    id={`a${section.uld_number}_${index}`}
                                    type="checkbox"
                                    checked={section.regd === 'R'}
                                    onChange={(e) => handleDetailsChange(section.uld_number, 'regd', e.target.checked ? 'R' : false)} />
                                  <label htmlFor={`a${section.uld_number}_${index}`}>
                                    <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                                  </label>
                                </div>
                              </td>
                            </>
                          )
                        }
                        <td>
                          <div className='chart_switch'>
                            <div className="switch6">
                              <label className="switch6-light">
                                <input type="checkbox"
                                  name="asset_type" />
                                <span>
                                  <span>Owned</span>
                                  <span>Lease</span>
                                </span>
                                <a className="btn btn-primary"></a>
                              </label>
                            </div>
                          </div>
                        </td> */}
                        {section.reg === 'R' || section.register == 'Y' ?
                          (
                            <>
                              <td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td>
                              <td className='rayes'>

                                {/* <div className="can-toggle">
                                  <input
                                    id={`a${section.uld_number}_d`} type="checkbox"
                                    disabled
                                    // ={section.reg && section.reg === 'R'} 
                                    checked
                                  // ={section.reg && section.reg === 'R'} 
                                  />
                                  <label htmlFor={`a${section.uld_number}_d`}>
                                    <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                                  </label>
                                </div> */}
                              </td>
                              <td></td>
                            </>
                          ) : (
                            <>
                              {section.regd == 'R' || section.register == 'Y' ?
                                (<><td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td></>
                                ) : (<><td className='non_register'><FontAwesomeIcon icon={faCircleXmark} /> Non-Registered</td></>)}
                              <td className='rayes'>
                                <div className="can-toggle">
                                  <input
                                    id={`a${section.uld_number}_${index}`}
                                    type="checkbox"
                                    checked={section.regd === 'R'}
                                    onChange={(e) => handleDetailsChange(section.uld_number, 'regd', e.target.checked ? 'R' : false)} />
                                  <label htmlFor={`a${section.uld_number}_${index}`}>
                                    <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                                  </label>
                                </div>
                              </td>
                              <td>
                                {section.regd == 'R' &&
                                  <div className='chart_switch'>
                                    <div className="switch6">
                                      <label className="switch6-light">
                                        <input type="checkbox"
                                          name="asset_type"
                                          checked={section.asset_type}
                                          onChange={(e) => handleDetailsChange(section.uld_number, 'asset_type', e.target.checked)} />
                                        <span>
                                          <span>Owned</span>
                                          <span>Lease</span>
                                        </span>
                                        <a className="btn btn-primary"></a>
                                      </label>
                                    </div>
                                  </div>
                                }
                              </td>
                            </>
                          )
                        }
                        <td>
                          <img src={Trash} onClick={() => removeDetails(section.uld_number)} />
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>

              {/* <div className='text-center mt-5'>
                <Button variant="light" className='stk_cancel'>CANCEL</Button>
                <Button variant="primary" className='stk_save'>UPDATE</Button>
              </div> */}
            </div>
          </>
        ) : (keyType == 'SCM' ? (
          <>
            <div className='table-responsive repar_h'>
              <Table className='uld_details'>
                <thead>
                  <tr>
                    <th>ULD Number</th>
                    <th>Type Code</th>
                    <th>Serial No</th>
                    <th>Owner</th>
                    <th>Condition</th>
                    <th className='non_reg'>ULD Asset</th>
                    <th>Register</th>
                    <th>Asset Type </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {formData && formData.map((section, index) => {
                    return (
                      <tr key={index}>
                        <td><Form.Control type="text" readOnly value={section.uld_number} /></td>
                        <td>
                          <Select
                            options={getTypeCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'type_code', e.value)}
                            placeholder="Type Code"
                            className='autoslct'
                            name="type_code"
                            value={getTypeCodes.find(option => option.value === section.type_code)}
                            isDisabled={true}
                          />
                        </td>
                        <td><Form.Control type="text" readOnly value={section.serial_number} /></td>
                        <td>
                          <Select
                            options={getOwnerCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'owner_code', e.value)}
                            placeholder="Owner Code"
                            className='autoslct'
                            name="owner_code"
                            value={getOwnerCodes.find(option => option.value === section.owner_code)}
                            // isDisabled={true}
                            isDisabled={section?.disabled == false || section?.register == 'N' ? false : true}
                          />
                        </td>
                        <td>
                          <Form.Select
                            aria-label="Default"
                            value={section.condition_code} // </td>== 'Damaged' ? 'DAM' : (section.condition_code == 'Discarded' ? 'DIS' : 'SER')
                            onChange={(e) => handleDetailsChange(section.uld_number, 'condition_code', e.target.value)}
                          >
                            {getCondCodes &&
                              Object.entries(getCondCodes).map((option, index) =>
                                <option key={index} value={option[0]}>{option[1]}</option>
                              )
                            }
                          </Form.Select>
                        </td>
                        {/* <td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td> */}
                        {section.reg === 'R' || section.register == 'Y' ?
                          (
                            <>
                              <td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td>
                              <td className='rayes'>

                                {/* <div className="can-toggle">
                                  <input
                                    id={`a${section.uld_number}_d`} type="checkbox"
                                    disabled
                                    // ={section.reg && section.reg === 'R'} 
                                    checked
                                  // ={section.reg && section.reg === 'R'} 
                                  />
                                  <label htmlFor={`a${section.uld_number}_d`}>
                                    <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                                  </label>
                                </div> */}
                              </td>
                              <td></td>
                            </>
                          ) : (
                            <>
                              {section.regd == 'R' || section.register == 'Y' ?
                                (<><td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td></>
                                ) : (<><td className='non_register'><FontAwesomeIcon icon={faCircleXmark} /> Non-Registered</td></>)}
                              <td className='rayes'>
                                <div className="can-toggle">
                                  <input
                                    id={`a${section.uld_number}_${index}`}
                                    type="checkbox"
                                    checked={section.regd === 'R'}
                                    onChange={(e) => handleDetailsChange(section.uld_number, 'regd', e.target.checked ? 'R' : false)} />
                                  <label htmlFor={`a${section.uld_number}_${index}`}>
                                    <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                                  </label>
                                </div>
                              </td>
                              <td>
                                {section.regd == 'R' &&
                                  <div className='chart_switch'>
                                    <div className="switch6">
                                      <label className="switch6-light">
                                        <input type="checkbox"
                                          name="asset_type"
                                          checked={section.asset_type}
                                          onChange={(e) => handleDetailsChange(section.uld_number, 'asset_type', e.target.checked)} />
                                        <span>
                                          <span>Owned</span>
                                          <span>Lease</span>
                                        </span>
                                        <a className="btn btn-primary"></a>
                                      </label>
                                    </div>
                                  </div>
                                }
                              </td>
                            </>
                          )
                        }
                        <td>
                          <img src={Trash} onClick={() => removeDetails(section.uld_number)} />
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>

              {/* <div className='text-center mt-5'>
                <Button variant="light" className='stk_cancel'>CANCEL</Button>
                <Button variant="primary" className='stk_save'>UPDATE</Button>
              </div> */}
            </div>
          </>
        ) : (keyType == 'UCM In' ? (
          <>
            <div className='table-responsive ucm_h'>
              <Table className='uld_details'>
                <thead>
                  <tr>
                    <th>ULD Number</th>
                    <th>Type Code</th>
                    <th>Serial No</th>
                    <th>Owner</th>
                    <th>Content</th>
                    {/* <th>Airline Name</th> */}
                    <th>Condition</th>
                    <th className='non_reg'>ULD Asset</th>
                    <th>Register</th>
                    <th>Asset Type </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {formData && formData.map((section, index) => {
                    return (
                      <tr>
                        <td><Form.Control type="text" readOnly value={section.uld_number} /></td>
                        <td>
                          <Select
                            options={getTypeCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'type_code', e.value)}
                            placeholder="Code"
                            className='autoslct'
                            name="type_code"
                            value={getTypeCodes.find(option => option.value === section.type_code) || ''}
                            isDisabled={section?.disabled ?? true}
                          />
                        </td>
                        <td><Form.Control type="text" readOnly={section?.disabled ?? true} value={section.serial_number || ''} /></td>
                        <td>
                          <Select
                            options={getOwnerCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'owner_code', e.value)}
                            placeholder="Owner"
                            className='autoslct'
                            name="owner_code"
                            value={getOwnerCodes.find(option => option.value === section.owner_code) || ''}
                            // isDisabled={section?.disabled ?? true}
                            isDisabled={section?.disabled == false || section?.register == 'N' ? false : true}
                          />
                        </td>
                        <td>
                          <Select
                            options={getContentCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'content_code', e.value)}
                            placeholder="Content"
                            className='autoslct'
                            name="content_code"
                            value={getContentCodes.find(option => option.value === section.content_code) || ''}
                          // isDisabled={true}
                          />
                          {/* <Form.Control type="text" name='content_code' onChange={(e) => handleDetailsChange(section.uld_number, 'content_code', e.target.value)} /> */}
                        </td>
                        {/* <td>
                          <Form.Control type="text" readOnly />
                        </td> */}
                        <td>
                          <Form.Select
                            aria-label="Default"
                            value={section.condition_code} // == 'Damaged' ? 'DAM' : (section.condition_code == 'Discarded' ? 'DIS' : 'SER')}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'condition_code', e.target.value)}
                          >
                            {getCondCodes &&
                              Object.entries(getCondCodes).map((option, index) =>
                                <option key={index} value={option[0]}>{option[1]}</option>
                              )
                            }
                          </Form.Select>
                        </td>
                        {section.reg === 'R' || section.register == 'Y' ?
                          (
                            <>
                              <td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td>
                              <td className='rayes'>

                                {/* <div className="can-toggle">
                                  <input
                                    id={`a${section.uld_number}_d`} type="checkbox"
                                    disabled
                                    // ={section.reg && section.reg === 'R'} 
                                    checked
                                  // ={section.reg && section.reg === 'R'} 
                                  />
                                  <label htmlFor={`a${section.uld_number}_d`}>
                                    <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                                  </label>
                                </div> */}
                              </td>
                              <td></td>
                            </>
                          ) : (
                            <>
                              {section.regd == 'R' || section.register == 'Y' ?
                                (<><td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td></>
                                ) : (<><td className='non_register'><FontAwesomeIcon icon={faCircleXmark} /> Non-Registered</td></>)}
                              <td className='rayes'>
                                <div className="can-toggle">
                                  <input
                                    id={`a${section.uld_number}_${index}`}
                                    type="checkbox"
                                    checked={section.regd === 'R'}
                                    onChange={(e) => handleDetailsChange(section.uld_number, 'regd', e.target.checked ? 'R' : false)} />
                                  <label htmlFor={`a${section.uld_number}_${index}`}>
                                    <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                                  </label>
                                </div>
                              </td>
                              <td>
                                {section.regd == 'R' &&
                                  <div className='chart_switch'>
                                    <div className="switch6">
                                      <label className="switch6-light">
                                        <input type="checkbox"
                                          name="asset_type"
                                          checked={section.asset_type}
                                          onChange={(e) => handleDetailsChange(section.uld_number, 'asset_type', e.target.checked)} />
                                        <span>
                                          <span>Owned</span>
                                          <span>Lease</span>
                                        </span>
                                        <a className="btn btn-primary"></a>
                                      </label>
                                    </div>
                                  </div>
                                }
                              </td>
                            </>
                          )
                        }
                        <td>
                          <img src={Trash} onClick={() => removeDetails(index)} />
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
              {/* <div className='text-end'><Button variant="primary" className='stk_add' onClick={addULDStack}> <FontAwesomeIcon icon={faPlus} />Add ULD</Button></div> */}
              {/* <div className='text-center mt-5'>
                <Button variant="light" className='stk_cancel'>CANCEL</Button>
                <Button variant="primary" className='stk_save'>UPDATE</Button>
              </div> */}
            </div>
          </>
        ) : (keyType == 'UCM Out' ? (
          <>{/* console.log('www', formData) */}
            <div className='table-responsive ucm_h'>
              <Table className='uld_details'>
                <thead>
                  <tr>
                    <th>ULD Number</th>
                    <th>Type Code</th>
                    <th>Serial No</th>
                    <th>Owner</th>
                    <th>Content</th>
                    <th>Final Dest.</th>
                    <th>Condition</th>
                    <th>Airway Bill</th>
                    <th className='non_reg'>ULD Asset</th>
                    <th>Register</th>
                    <th>Asset Type </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {formData && formData.map((section, index) => {
                    return (
                      <tr key={index}>
                        <td><Form.Control type="text" readOnly value={section?.uld_number} /></td>
                        <td>
                          <Select
                            options={getTypeCodes}
                            // onChange={(selected) => {
                            //   const updatedData = formData.map(item => {
                            //     if (item.rowId === section.rowId) {
                            //       return { ...item, type_code: selected.value, uld_number: selected.value + item.serial_number + item.owner_code };
                            //     }
                            //     return item;
                            //   });
                            //   setFormData(updatedData);
                            //   if (formData.serial_number && formData.owner_code) {
                            //     handleCheckUld('type_code', selected.value)
                            //   }
                            // }}
                            onChange={(selected) => handleUldChange(index, "type_code", selected.value)}
                            placeholder="Code"
                            className='autoslct'
                            name="type_code"
                            value={getTypeCodes.find(option => option.value === section?.type_code) || ''}
                            isDisabled={section?.disabled ?? true}
                          />
                        </td>
                        <td>
                          <Form.Control
                            type="text" readOnly={section?.disabled ?? true}
                            value={section?.serial_number || ''}
                            // onChange={(e) => {
                            //   const updatedData = formData.map(item => {
                            //     if (item.rowId === section.rowId) {
                            //       return { ...item, serial_number: e.target.value, uld_number: item.type_code + e.target.value + item.owner_code };
                            //     }
                            //     return item;
                            //   });
                            //   setFormData(updatedData);
                            //   if (formData.type_code && formData.owner_code) {
                            //     handleCheckUld('serial_number', e.target.value)
                            //   }
                            // }}
                            onChange={(e) => handleUldChange(index, "serial_number", e.target.value)}
                          />
                        </td>
                        <td>
                          <Select
                            options={getOwnerCodes}
                            // onChange={(selected) => {
                            //   const updatedData = formData.uldInfo.map(item => {
                            //     if (item.rowId === section.rowId) {
                            //       return { ...item, owner_code: selected.value, uld_number: item.type_code + item.serial_number + selected.value };
                            //     }
                            //     return item;
                            //   });
                            //   setFormData({ ...formData, uldInfo: updatedData });
                            //   if (formData.type_code && formData.serial_number) {
                            //     handleCheckUld('serial_number', e.target.value)
                            //   }
                            // }}
                            onChange={(selected) => handleUldChange(index, "owner_code", selected.value)}
                            // onChange={(e) => handleDetailsChange(section.uld_number, 'owner_code', e.value)}
                            placeholder="Owner"
                            className='autoslct'
                            name="owner_code"
                            value={getOwnerCodes.find(option => option.value === section?.owner_code) || ''}
                            isDisabled={section?.disabled == false || section?.register == 'N' ? false : true}
                          />
                        </td>
                        <td>
                          <Select
                            options={getContentCodes}
                            onChange={(e) => handleDetailsChange(section?.uld_number, 'content_code', e.value)}
                            placeholder="Content"
                            className='autoslct'
                            name="content_code"
                            value={getContentCodes.find(option => option.value === section?.content_code) || ''}
                          // isDisabled={true}
                          />
                          {/* <Form.Control type="text" name='content_code' onChange={(e) => handleDetailsChange(section?.uld_number, 'content_code', e.target.value)} /> */}
                        </td>
                        <td>
                          <Select
                            options={getDestination}
                            onChange={(e) => handleDetailsChange(section?.uld_number, 'final_dest', e.value)}
                            placeholder="Destination"
                            className='autoslct'
                            name="final_dest"
                            value={getDestination.find(option => option.value === section?.final_dest) || ''}
                          />
                        </td>
                        <td>
                          <Form.Select aria-label="Default" value={section?.condition_code} onChange={(e) => handleDetailsChange(section?.uld_number, 'condition_code', e.target.value)}>
                            {getCondCodes &&
                              Object.entries(getCondCodes).map((option, index) =>
                                <option key={index} value={option[0]}>{option[1]}</option>
                              )
                            }
                          </Form.Select>
                        </td>
                        <td>
                          {/* <Form.Control
                            type="text"
                            name="Airway Bill"
                            value={section?.airway_bill}

                          /> */}
                          <Form.Control type="text"
                            name='awb_number'
                            value={section?.awb_number || ''}
                            maxLength={13}
                            // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                            onChange={(e) => handleDetailsChange(section?.uld_number, 'awb_number', e.target.value)}
                          />
                        </td>
                        {section?.reg === 'R' || section?.register == 'Y' ?
                          (
                            <>
                              <td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td>
                              <td className='rayes'>

                                {/* <div className="can-toggle">
                                  <input
                                    id={`a${section.uld_number}_d`} type="checkbox"
                                    disabled
                                    // ={section.reg && section.reg === 'R'} 
                                    checked
                                  // ={section.reg && section.reg === 'R'} 
                                  />
                                  <label htmlFor={`a${section.uld_number}_d`}>
                                    <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                                  </label>
                                </div> */}
                              </td>
                              <td></td>
                            </>
                          ) : (
                            <>
                              {section?.regd == 'R' || section?.register == 'Y' ?
                                (<><td className='register'> <FontAwesomeIcon icon={faCircleCheck} /> Registered </td></>
                                ) : (<><td className='non_register'><FontAwesomeIcon icon={faCircleXmark} /> Non-Registered</td></>)}
                              <td className='rayes'>
                                <div className="can-toggle">
                                  <input
                                    id={`a${section?.uld_number}_${index}`}
                                    type="checkbox"
                                    checked={section?.regd === 'R'}
                                    onChange={(e) => handleDetailsChange(section?.uld_number, 'regd', e.target.checked ? 'R' : false)} />
                                  <label htmlFor={`a${section?.uld_number}_${index}`}>
                                    <div className="can-toggle__switch" data-checked="Yes" data-unchecked="No"></div>
                                  </label>
                                </div>
                              </td>
                              <td>
                                {section?.regd == 'R' &&
                                  <div className='chart_switch'>
                                    <div className="switch6">
                                      <label className="switch6-light">
                                        <input type="checkbox"
                                          name="asset_type"
                                          checked={section?.asset_type}
                                          onChange={(e) => handleDetailsChange(section?.uld_number, 'asset_type', e.target.checked)} />
                                        <span>
                                          <span>Owned</span>
                                          <span>Lease</span>
                                        </span>
                                        <a className="btn btn-primary"></a>
                                      </label>
                                    </div>
                                  </div>
                                }
                              </td>
                            </>
                          )
                        }
                        <td>
                          <img src={Trash} onClick={() => removeDetails(index)} />
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
              <div className='text-end'><Button variant="primary" className='stk_add' onClick={addULDStack}> <FontAwesomeIcon icon={faPlus} />Add ULD</Button></div>
              {/* <div className='text-center mt-5'>
                <Button variant="light" className='stk_cancel'>CANCEL</Button>
                <Button variant="primary" className='stk_save'>UPDATE</Button>
              </div> */}
            </div>
          </>
        ) : (keyType == 'Transfer' ? (
          <>
            <div className='table-responsive luc_h'>
              <Table className='uld_details transer_tble'>
                <thead>
                  <tr>
                    <th>ULD Number</th>
                    <th>Type Code</th>
                    <th>Serial No</th>
                    <th>Owner Code</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {formData && formData.map((section, index) => {
                    return (
                      <tr key={index}>
                        <td><Form.Control type="text" readOnly value={section.uld_number} /></td>
                        <td>
                          <Select
                            options={getTypeCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'type_code', e.value)}
                            placeholder="Type Code"
                            className='autoslct'
                            name="type_code"
                            value={getTypeCodes.find(option => option.value === section.type_code)}
                            isDisabled={true}
                          />
                        </td>
                        <td><Form.Control type="text" readOnly value={section.serial_number} /></td>
                        <td>
                          <Select
                            options={getOwnerCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'owner_code', e.value)}
                            placeholder="Owner Code"
                            className='autoslct'
                            name="owner_code"
                            value={getOwnerCodes.find(option => option.value === section.owner_code)}
                            isDisabled={true}
                          />
                        </td>
                        <td>
                          <img src={Trash} onClick={() => removeDetails(section.uld_number)} />
                        </td>
                      </tr>
                    )
                  })}

                </tbody>
              </Table>
            </div>
          </>
        ) : (keyType == 'Request' ? (
          <>
            <div className='table-responsive luc_h'>
              <Table className='uld_details transer_tble'>
                <thead>
                  <tr>
                    <th>ULD Number</th>
                    <th>Type Code</th>
                    <th>Serial No</th>
                    <th>Owner Code</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {formData && formData.map((section, index) => {
                    return (
                      <tr key={index}>
                        <td><Form.Control type="text" readOnly value={section.uld_number} /></td>
                        <td>
                          <Select
                            options={getTypeCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'type_code', e.value)}
                            placeholder="Type Code"
                            className='autoslct'
                            name="type_code"
                            value={getTypeCodes.find(option => option.value === section.type_code)}
                            isDisabled={true}
                          />
                        </td>
                        <td><Form.Control type="text" readOnly value={section.serial_number} /></td>
                        <td>
                          <Select
                            options={getOwnerCodes}
                            onChange={(e) => handleDetailsChange(section.uld_number, 'owner_code', e.value)}
                            placeholder="Owner Code"
                            className='autoslct'
                            name="owner_code"
                            value={getOwnerCodes.find(option => option.value === section.owner_code)}
                            isDisabled={true}
                          />
                        </td>
                        <td>
                          <img src={Trash} onClick={() => removeDetails(section.uld_number)} />
                        </td>
                      </tr>
                    )
                  })}

                </tbody>
              </Table>
            </div>
          </>
        ) : (
          <></>
        )))))))))}

        <div className='text-center mt-5'>
          {/* <Loader isLoading={isLoading} /> */}
          {console.log('scmResponseData', scmResponseData)}
          <Button variant="light" className='stk_cancel' onClick={() => handleModalOpen('cancelForm')}>CANCEL</Button>
          <Button variant="primary" className='stk_save posr' onClick={() => updateData('')} disabled={isLoading}>UPDATE
            {/* {isLoading ? <>UPDATE<div className='mvt loader-container'><span className='mvt loader'></span></div></> : 'UPDATE'} */}
          </Button>
        </div>
      </div>
      <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          {modalContent === 'assetTypeChange' && (
            <>
              <h3>All Asset Type Changes</h3>
              <p>Are sure you want to change all asset type?</p>
              <div className='asset_midle'>
                <Form.Check
                  type='radio'
                  label='Owned'
                  name='assetType'
                  id='own'
                  value='O'
                  checked={modalRadioValue.assetType === 'O'}
                  onChange={handleModalRadioChange}
                />
                <Form.Check
                  type='radio'
                  label='Lease'
                  name='assetType'
                  id='lease'
                  value='L'
                  checked={modalRadioValue.assetType === 'L'}
                  onChange={handleModalRadioChange}
                />
              </div>
            </>
          )}
          {modalContent === 'regChange' && (
            <>
              <h3>Register or Unregister All Asset</h3>
              <p>Are sure you want to change all asset?</p>
              <div className='asset_midle'>
                <Form.Check
                  type='radio'
                  label='Register'
                  name='regType'
                  id='own'
                  value='R'
                  checked={modalRadioValue.regType === 'R'}
                  onChange={handleModalRadioChange}
                />
                <Form.Check
                  type='radio'
                  label='Unregister'
                  name='regType'
                  id='lease'
                  value='U'
                  checked={modalRadioValue.regType === 'U'}
                  onChange={handleModalRadioChange}
                />
              </div>
            </>
          )}
          {modalContent === 'cancelForm' && (
            <>
              <h3>All changes will be destroyed</h3>
              <p>If you proceed with the change, all data in this section will be removed.
                Are you sure you want to continue?</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {modalContent === 'assetTypeChange' &&
            <>
              <Button variant='primary' onClick={handleModalUpdate}>
                Update Asset Type
              </Button>
            </>
          }
          {modalContent === 'regChange' &&
            <>
              <Button variant='primary' onClick={handleModalUpdate}>
                Update
              </Button>
            </>
          }
          {modalContent === 'cancelForm' &&
            <>
              <div className='d-flex w-50 mx-auto are_bottom'>
                <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                  No
                </Button>
                <Button variant="primary" onClick={() => handleConfirmation(true)}>
                  Yes
                </Button>
              </div>
            </>
          }
        </Modal.Footer>
      </Modal>
      <Modal show={showModalUpload} onHide={() => setShowModalUpload(false)} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <div className='type_work'>

            <div className='ra_condition'>
              <div
                className='dropfile'
                onDrop={handleDrop}
                onDragOver={handleDragOver}
              >
                <h3>Drag and drop files here</h3>
                <p>Or</p>
                <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse Files</button>
                <span>Maximum file size 4 MB</span>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: 'none' }}
                  onChange={handleFileChange}
                  multiple
                />
              </div>
              <div className='uploadbox'>
                {files.map((file, index) => (
                  <div key={index} className='uploadfil'>
                    {file.type?.startsWith('image/') ? (
                      <img
                        src={URL.createObjectURL(file)}
                        alt="Preview"
                        style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                      />
                    ) : (
                      <span className='d-flex'><img src={Docmnt} className='fileimg' /> {file.name}</span>
                    )}
                    <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="primary" onClick={imageUpload}>
              Upload
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={scmModal} onHide={() => setScmModal(false)} className={`addfrom change_type ${keyType == 'SCM' ? 'scm_pop' : 'ucm_pop'}`} centered>
        <Modal.Header closeButton>
          <h4 className='modal-title'>{keyType} Discrepancies</h4>
          <p className='text-start'>System detected mismatches between {keyType} message and station stock.</p>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex mb-3'>
            <div className='instock'>
              <span className='inscm'><FontAwesomeIcon icon={faCircleCheck} /> In Stock</span>
              <span>ULDs - {scmResponseData?.in_stock}</span>
            </div>
            {keyType == 'SCM' &&
              <div className='instock'>
                <span className='inmiss'><FontAwesomeIcon icon={faCircleInfo} /> Missing</span>
                <span>ULDs - {scmResponseData?.missing_uld_count}</span>
              </div>
            }
            <div className='instock'>
              <span className='inunexpec'><FontAwesomeIcon icon={faCircleQuestion} /> Unexpected</span>
              <span>ULDs - {scmResponseData?.unexpected_stock_count}</span>
            </div>
            <div className='instock'>
              <span className='inunexpec'><FontAwesomeIcon icon={faTruckRampBox} /> Old Movement</span>
              <span>ULDs - {scmResponseData?.old_moved_data}</span>
            </div>
          </div>

          <Row>
            {keyType == 'SCM' &&
              < Col sm={6}>
                <div className='missing_info'>

                  <div className='d-flex justify-content-between all_action'>
                    <div>
                      <h4>Missing ULDs -  {scmResponseData?.missing_uld_count}</h4>
                      <p>ULDs that should be present at the location according to system</p>
                    </div>

                    <div>
                      {scmResponseData?.missing_ulds.length > 0 &&
                        <Form.Select aria-label="Select" name='allAction' onChange={(e) => handleAllChange(e, 'missing')}>
                          <option value="">Select</option>
                          <option value="Mismatch">Mismatch</option>
                          <option value="Missing">Missing</option>
                          <option value="None">None</option>
                        </Form.Select>
                      }
                    </div>
                  </div>

                  {scmResponseData?.missing_ulds.length > 0 ?
                    <>
                      <Table className='unknowmd'>
                        <thead>
                          <tr>
                            <th>Type Code</th>
                            <th>Serial Number</th>
                            <th>Owner Code</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {scmResponseData.missing_ulds.map((uld, index) => (
                            <>
                              <tr key={`${index}_muld`}>
                                <td><Form.Control type="text" value={uld.type_code} /></td>
                                <td><Form.Control type="text" value={uld.serial_number} /></td>
                                <td><Form.Control type="text" value={uld.owner_code} /></td>
                                <td>
                                  <Form.Select aria-label="Select" name='action' value={uld.action} onChange={(e) => handleActionChange(e, index, "missing")}>
                                    <option value="Mismatch">Mismatch</option>
                                    <option value="Missing">Missing</option>
                                    <option value="None">None</option>
                                  </Form.Select>
                                </td>
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </Table>
                    </>
                    : <span>There is no missing ULD</span>
                  }

                </div>
              </Col>
            }
            <Col sm={keyType == 'SCM' ? 6 : 12}>
              <div className='missing_info'>
                <div className='d-flex justify-content-between all_action'>
                  <div>
                    <h4>Unexpected ULDs - {scmResponseData?.unexpected_stock_count}</h4>
                    <p>{keyType == 'SCM' ?
                      'ULDs present in SCM, but not at that location according to system.'
                      :
                      'ULDs in the UCM Out message but not present at the departure station.'
                    }
                    </p>
                  </div>

                  <div>
                    {scmResponseData?.unexpected_stock_ulds.length > 0 &&
                      <Form.Select aria-label="Select" name='allAction' onChange={(e) => handleAllChange(e, 'unknown')}>
                        <option value="">All Action</option>
                        <option value="Mismatch">Mismatch</option>
                        <option value="Missing">Missing</option>
                        <option value="None">None</option>
                      </Form.Select>
                    }
                  </div>
                </div>

                {scmResponseData?.unexpected_stock_ulds.length > 0 ?
                  <>
                    <Table className='unknowm_right'>
                      <thead>
                        <tr>
                          <th>Type Code</th>
                          <th>Serial Number</th>
                          <th>Owner Code</th>
                          <th>Current Location</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {scmResponseData.unexpected_stock_ulds.map((uld, index) => (
                          <>
                            <tr key={`${index}_muld`}>

                              <td><Form.Control type="text" value={uld.type_code} /></td>
                              <td><Form.Control type="text" value={uld.serial_number} /></td>
                              <td><Form.Control type="text" value={uld.owner_code} /></td>
                              <td><Form.Control type="text" value={uld.current_location} /></td>
                              <td>
                                <Form.Select aria-label="Select" name='action' value={uld.action} onChange={(e) => handleActionChange(e, index, "unknown")}>
                                  <option value="Mismatch">Mismatch</option>
                                  <option value="Missing">Missing</option>
                                  <option value="None">None</option>
                                </Form.Select>
                              </td>
                            </tr>
                          </>
                        ))}
                      </tbody>
                    </Table>
                  </>
                  : <span>There is no unexpected ULD</span>
                }
                {/* <Table className='awbset'>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Username</th>
                      <th>Username</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Mark</td>
                      <td>Otto</td>
                      <td>@mdo</td>
                      <td>@mdo</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Jacob</td>
                      <td>Thornton</td>
                      <td>@fat</td>
                      <td>@mdo</td>
                    </tr>

                  </tbody>
                </Table> */}
              </div>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="danger" className='cancle' onClick={() => setScmModal(false)}>Cancel</Button>
            <Button variant="primary" onClick={() => updateData('P')}>Process</Button>
          </div>
        </Modal.Footer>
      </Modal >
    </>
  )
}

export default Details